export default __webpack_public_path__ + "static/media/negative-carbon-balance.945abc0a.svg";